export default __webpack_public_path__ + "static/media/flashcards-qr.b5a167ec.png";